import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=7dd5620f&scoped=true"
import script from "./Paginacao.vue?vue&type=script&lang=ts"
export * from "./Paginacao.vue?vue&type=script&lang=ts"
import style0 from "./Paginacao.vue?vue&type=style&index=0&id=7dd5620f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd5620f",
  null
  
)

export default component.exports